import { Skeleton as PRSkeleton } from "primereact/skeleton";
import { type SkeletonProps } from "./skeleton.interface";

export const Skeleton = ({ borderRadius, ...props }: SkeletonProps) => {
	return <PRSkeleton borderRadius={borderRadius?.toString()} {...props} />;
};
